import { useCallback, useState } from "react";
import { colors, transitions } from "../../../styles/theme.js";
import { RxCross2, RxMagnifyingGlass } from "react-icons/rx";

const styles = {
  container: {
    position: "relative",
  },
  input: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    padding: "10px 10px",
    flexGrow: 1,
    fontSize: 16,
    border: "none",
    outline: "none",
    transition: transitions.default,
    boxSizing: "border-box",
    backgroundColor: colors.secondaryBackground,
    color: colors.text,
  },
  inputFocused: {
    borderColor: colors.primary,
    boxShadow: `0 0 0 3px ${colors.primary}20`,
  },
  inputBlurred: {
    borderColor: colors.border,
    boxShadow: "none",
  },
};

const buttonStyles = {
  position: "absolute",
  right: 12,
  top: "50%",
  transform: "translateY(-50%)",
  background: "none",
  border: "none",
  fontSize: 20,
  cursor: "pointer",
  color: colors.textSecondary,
  padding: "4px 8px",
};

const SearchInput = ({ value, onChange, placeholder = "Search..." }) => {
  const [focused, setFocused] = useState(false);

  const handleFocus = useCallback(() => {
    setFocused(true);
  }, [setFocused]);

  const handleBlur = useCallback(() => {
    setFocused(false);
  }, [setFocused]);

  const handleClear = useCallback(() => {
    onChange("");
  }, [onChange]);

  const handleChange = useCallback(
    (e) => {
      onChange(e.target.value);
    },
    [onChange]
  );

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        flexDirection: "row",
        paddingLeft: 10,
        paddingRight: 17,
        paddingBottom: 10,
        borderBottom: `3px solid ${colors.background}`,
      }}
    >
      <RxMagnifyingGlass size={30} style={{ color: colors.textSecondary }} />
      <input
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onFocus={handleFocus}
        onBlur={handleBlur}
        style={{
          ...styles.input,
          ...(focused ? styles.inputFocused : styles.inputBlurred),
          outline: "none",
          boxShadow: "none",
        }}
      />
      <style>{`
        input::placeholder {
          color: ${colors.textTertiary};
        }
      `}</style>
      {value && (
        <div
          style={{
            cursor: "pointer",
            color: colors.textSecondary,
            display: "flex",
            alignItems: "center",
          }}
        >
          <RxCross2 size={20} onClick={handleClear} />
        </div>
      )}
    </div>
  );
};

export default SearchInput;
